type ReportType = "swimmers" | "news" | "management" | "consolidated";

interface BuildReportFileNameParams {
  reportType: ReportType;
  buildingName: string;
  startDate: string;
  endDate: string;
  extension: "xlsx" | "pdf";
}

const INVALID_FILENAME_CHARS_REGEX = /[\\/:*?"<>|]/g;

const sanitizeFileNamePart = (value: string): string =>
  value
    .replace(INVALID_FILENAME_CHARS_REGEX, " ")
    .replace(/\s+/g, " ")
    .trim();

const toIsoDateIfPossible = (value: string): string | undefined => {
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return value;
  }

  if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
    const [day, month, year] = value.split("/");
    return `${year}-${month}-${day}`;
  }

  return undefined;
};

const getDateLabel = (startDate: string, endDate: string): string => {
  const normalizedStart = toIsoDateIfPossible(startDate) ?? startDate;
  const normalizedEnd = toIsoDateIfPossible(endDate) ?? endDate;
  return `${normalizedStart} a ${normalizedEnd}`;
};

export const buildReportFileName = ({
  reportType,
  buildingName,
  startDate,
  endDate,
  extension,
}: BuildReportFileNameParams): string => {
  const safeBuildingName = sanitizeFileNamePart(buildingName || "Todas las unidades residenciales");
  const safeDateLabel = sanitizeFileNamePart(getDateLabel(startDate, endDate));

  const baseName =
    reportType === "swimmers"
      ? `Registro de Bañistas - ${safeBuildingName} - ${safeDateLabel}`
      : reportType === "management"
        ? `Informe de Gestión - ${safeBuildingName} - ${safeDateLabel}`
        : reportType === "consolidated"
          ? `Consolidado - ${safeDateLabel}`
        : `${safeBuildingName} - BITACORA DE NOVEDADES OPERATIVAS - ${safeDateLabel}`;

  return `${sanitizeFileNamePart(baseName)}.${extension}`;
};

export type { ReportType };
